/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkDayAvailability } from '../models/WorkDayAvailability';
import type { WorkDayAvailabilityManager } from '../models/WorkDayAvailabilityManager';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkdayAvailabilityService {
  /**
   * View set WorkDayAvailability from the Employee's perspective.
   * @returns WorkDayAvailability
   * @throws ApiError
   */
  public static workdayAvailabilityActivitiesList({
    organisationUid,
    dendGt,
    dstartLt,
  }: {
    organisationUid: string,
    dendGt?: string,
    dstartLt?: string,
  }): CancelablePromise<Array<WorkDayAvailability>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/workday_availability/activities',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'dend__gt': dendGt,
        'dstart__lt': dstartLt,
      },
    });
  }
  /**
   * View set for the WorkDayAvailability from the Manager's perspective.
   * @returns WorkDayAvailabilityManager
   * @throws ApiError
   */
  public static workdayAvailabilityManagerList({
    organisationUid,
    contactUid,
    contactUidIn,
    dendGt,
    dstartLt,
  }: {
    organisationUid: string,
    contactUid?: string,
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<string>,
    dendGt?: string,
    dstartLt?: string,
  }): CancelablePromise<Array<WorkDayAvailabilityManager>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/workday_availability/manager',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'contact__uid': contactUid,
        'contact__uid__in': contactUidIn,
        'dend__gt': dendGt,
        'dstart__lt': dstartLt,
      },
    });
  }
}
